<template>
  <div class="dados">
    <h1 class="font-weight-bold text-uppercase ml-2" id="inicio">Meus Dados</h1>
    <hr class="linha-amarela ml-2" />
    
    <div class="d-flex justify-content-end">
      <b-button 
        class="mr-3" 
        variant="danger"
        @click="$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/watch?v=LVz0ZeH1zAc&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=17', 
          title: 'Meus Dados' 
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
    </div>
   
    <div class="container col mt-4">
      <i class="fas fa-sign-in-alt fa-2x c-orange mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Dados de Acesso
      </h4>

      <div class="row col mt-3">
        <div class="col-md-4 form-group">
          <label for="email" class="font-weight-bold">E-mail:</label><br />
          <input
            type="text"
            class="form-control"
            v-model="dados.email"
            readonly
          />
        </div>

        <div class="col-md-4 form-group">
          <label class="font-weight-bold">Senha:</label><br />
          <input
            type="password"
            class="form-control"
            v-model="dados.password"
            placeholder="******"
          />
          <p class="error-message text-danger" v-if="ErrorMessages.password !== null">
            {{ ErrorMessages.password }}
          </p>
        </div>

        <div class="col-md-4 form-group">
          <label class="font-weight-bold">Confirme a senha:</label><br />
          <input
            type="password"
            class="form-control"
            v-model="dados.repassword"
            placeholder="******"
          />
          <p class="error-message text-danger" v-if="ErrorMessages.confirmPassword !== null">
            {{ ErrorMessages.confirmPassword }}
          </p>
        </div>

        <div class="form-group text-center col-md-12">
          <button class="btn btn-success text-white" @click="editarSenha()">
            Atualizar senha
          </button>
        </div>
      </div>

      <hr />

      <i class="fas fa-user-circle c-orange fa-2x mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Dados da Conta
      </h4>
      <div class="row">
        <div class="col-md-12">
          <div class="row col-12 mt-3">
            <div class="form-group col-md-6">
              <label for="nome" class="font-weight-bold">Nome:</label><br />
              <input
                type="text"
                class="form-control"
                v-model="dados.name"
              />
            </div>

            <div class="form-group col-md-6">
              <label class="font-weight-bold">CPF:</label><br />
              <input
                type="text"
                class="form-control"
                v-mask="'###.###.###-##'"
                v-model="dados.cpf"
              />
            </div>
          </div>

          <div class="row col-12">
            <div class="form-group col-md-6">
              <label class="font-weight-bold">Whatsapp:</label>
              <input
                type="text"
                class="form-control"
                id="whatsapp"
                name="whatsapp"
                v-model="dados.phone"
                v-mask="['(##) #####-####', '(##) ####-####']"              
              />     
            </div>

            <div class="form-group col-md-6">
              <label class="font-weight-bold">Cupom:</label>
              <input
                type="text"
                class="form-control"
                id="whatsapp"
                name="whatsapp"
                v-model="dados.code"              
              />     
            </div>
          </div>

          <div class="form-group text-center col-md-12">
            <button class="btn btn-success text-white" @click="editarDados()">
              Atualizar dados
            </button>
          </div>
        </div>
      </div>

    </div>
    <VideoManual ref="videoManual"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import makeToast from "../../mixins/makeToast";
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: "MeusDadosBalconista",
  mixins: [makeToast],
  components: {
    VideoManual
  },
  data: () => ({
    dados: {
      email: null,
      password: null,
      repassword: null,
      name: null,
      cpf: null,
      phone: null,
      code: null,
    },
    ErrorMessages: {
      password: null,
      confirmPassword: null,
    },
  }),
  computed: {
    ...mapState(['token', 'dadosUsuario'])
  },
  created() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.dados.email = this.dadosUsuario.email;
    this.dados.name = this.dadosUsuario.nome_usuario;
    this.dados.cpf = this.dadosUsuario.cpf;
    this.dados.phone = this.dadosUsuario.phone;
    this.dados.code = this.dadosUsuario.code;
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    editarSenha() {
      if(this.validatePassword() == true) {
        const data = {
          password: this.dados.password,
          id: this.dadosUsuario.id
        }

        this.$store.dispatch('startLoader');
        this.$store.dispatch('balconista/updateSenhaBalconista', data)
          .then(() => {
            this.dados.password = null;
            this.dados.repassword = null;
            this.makeToast('sucesso', 'Senha atualizada com sucesso!', 'success');
          })
          .catch(() => {
            this.makeToast('Oopss', 'Erro ao atualizar!', 'danger')
          })
          .finally(() => {
            this.$store.dispatch('endLoader')
          });
      }
    },
    editarDados() {
      const data = {
        name: this.dados.name,
        cpf: this.dados.cpf,
        code: this.dados.code,
        phone: this.dados.phone,
        id: this.dadosUsuario.id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('balconista/updateDadosBalconista', data)
        .then(() => {
          this.makeToast('sucesso', 'Dados atualizados com sucesso!', 'success');
        })
        .catch(() => {
          this.makeToast('Oopss', 'Erro ao atualizar!', 'danger')
        })
        .finally(() => {
          this.$store.dispatch('endLoader')
        });
    },
    validatePassword() {
      let isValid = true;

      if (!this.$validate.password(this.dados.password)) {
        this.ErrorMessages.password = 'A senha precisa ter no mínimo 5 caracteres';
        isValid = false;
      } else {
        this.ErrorMessages.password = null;
      }

      if (this.dados.repassword !== this.dados.password) {
        this.ErrorMessages.confirmPassword = 'As senhas devem ser iguais';
        isValid = false;
      } else {
        this.ErrorMessages.confirmPassword = null;
      }

      return isValid;
    },
  },
};
</script>
